import { IMusicDTO } from '@/modules/musics/dto/music.dto';
import { IMusic } from '@/modules/musics/entities/music.entity';

export class MusicMapper {
  public static toPresentation(music: IMusicDTO): IMusic {
    return {
      id: music.id,
      name: music.nome,
      duration: music.duracao,
      description: music.descricao,
      previewUrl: music.previewUrl,
    };
  }

  public static toDTO(music: IMusic): IMusicDTO {
    return {
      id: music.id,
      nome: music.name,
      descricao: music.description,
      previewUrl: music.previewUrl,
      duracao: music.duration ?? 0,
    };
  }
}
